module.exports = __webpack_public_path__ + "static/media/halasz_grip.3121ad05.jpg";